import { useEffect, useRef } from "react";
import { options } from "./config";
import { getVideoTipo, formatVideoTagForDataLayer } from "@/helpers/analitics";

const JWPlayer = ({
  id,
  statePlayerHover = "",
  autostart = true,
  controls = true,
  mute = true,
  repeat = false,
  entityId = "",
  playerScript,
  thumbnail = "",
  title = "",
  type,
  setDuration,
  setLastFrame = false,
  handleEventComplete = () => {},
  configType = '',
  isPreview = false,
  jwPlayerCdnLink = process.env.NEXT_PUBLIC_JWPLAYER_ID,
  isVertical = false,
  videoTag: videoTagOverride = "",
}) => {

  const videoTagFromPlaylistRef = useRef("");

  const nameCustomEvent = playerScript;
  const videoRef = useRef();
  const playerInstance = useRef(null);
  const idDivPlayer = type + entityId;
  const comsCore = "https://census-web.scorecardresearch.com/plugins/streaming-jwplayer/v2/current.js";
  const publisherIdComscore = "6906409";
  let config;

  if (
    playerScript &&
    typeof playerScript === "string" &&
    playerScript.trim().startsWith("{") &&
    playerScript.trim().endsWith("}")
  ) {
    try {
      config = JSON.parse(playerScript);
    } catch (error) {
      console.error("Error al parsear playerScript:", error);
      config = options?.[configType] ?? {};
    }
  } else {
    config = options?.[configType] ?? {};
    jwPlayerCdnLink = playerScript || jwPlayerCdnLink;
  }

  const installPlayerScript = () => {
    if (!document.getElementById(jwPlayerCdnLink)) {
      const jwPlayerScript = document.createElement("script");
      jwPlayerScript.id = jwPlayerCdnLink;
      jwPlayerScript.src = jwPlayerCdnLink;
      jwPlayerScript.async = true;
      jwPlayerScript.onload = () => {
        document.dispatchEvent(new CustomEvent(nameCustomEvent));
        initialize();
      };
      document.body.appendChild(jwPlayerScript);
    }

    installComsCoreScript();
  };

  const installComsCoreScript = () => {
    if (!document.getElementById("comsCoreScript")) {
      const comesCore = document.createElement("script");
      comesCore.id = "comsCoreScript";
      comesCore.src = comsCore;
      comesCore.async = true;
      document.body.appendChild(comesCore);
    }
  };


  const initialize = () => {
    
    document.removeEventListener(nameCustomEvent, initialize);
    if (!window.jwplayer) {
      console.error('JWPlayer no está cargado correctamente');
      return;
    }
    const player = window.jwplayer(videoRef.current);
    playerInstance.current = player;
    const playerOpts = {
      controls,
      image: thumbnail,
      playlist: `https://cdn.jwplayer.com/v2/media/${entityId}`,
      mute,
      repeat,
      autoPause: {
        viewability: true,
        pauseAds: true
      },
      ...config
    };

    if (videoRef.current) {
      player.setup(playerOpts);
      player.on('ready', function () {
        if (setDuration) { setDuration(this.getDuration()) };

        try {
          const item = window.jwplayer(idDivPlayer).getPlaylistItem();
          videoTagFromPlaylistRef.current = formatVideoTagForDataLayer(
            item?.tags
          );
        } catch {
          videoTagFromPlaylistRef.current = "";
        }

        const labelVideo = JSON.parse(window.jwplayer(idDivPlayer).getPlaylistItem().comscore);
        ns_.ComscoreJWPlayerPlugin(player, {
          publisherId: publisherIdComscore,
          labelmapping: `c3="${labelVideo.c3}", c4="*null", c6="*null", ns_st_st="${labelVideo.c3}", ns_st_pu="Clarin Digital", ns_st_pr="${labelVideo.ns_st_pr}", ns_st_ep="${labelVideo.ns_st_ep}", ns_st_sn="*null", ns_st_en="*null", ns_st_ge="News", ns_st_ia="0", ns_st_ce="0", ns_st_ddt="*null", ns_st_tdt="*null"`
        });
      });
      playbackEvents();
    }
  };

  const playbackEvents = () => {
    window.jwplayer(videoRef.current).on("play", () => sendData("resume"));
    window.jwplayer(videoRef.current).on("pause", () => sendData("pause"));
    window.jwplayer(videoRef.current).on("complete", () => {
      sendData("complete");
      handleEventComplete();
    });
    window.jwplayer(videoRef.current).on("firstFrame", function () {
      sendData("start");      
    });
    window.jwplayer(videoRef.current).on("adStarted", function () {
      sendData("adStarted");
    });
    window.jwplayer(videoRef.current).on("adPlay", function () {
      sendData("adPlay");
    });
    window.jwplayer(videoRef.current).on("adPause", function () {
      sendData("adPause");
    });
    window.jwplayer(videoRef.current).on("adComplete", function () {
      sendData("adComplete");
    });
    if(setLastFrame) {
      window.jwplayer(videoRef.current).on('time', function(event) {
          var duration = event.duration;
          var position = event.position;

          if (duration - position <= .2) {
              window.jwplayer(videoRef.current).pause();
          }
      })
    }
  };

  const sendData = (event) => {
    if (["start", "start2", "adstart", "adplay"].includes(event)) {
      CLATimer.pause();
    } else if (["pause", "complete", "adpause", "adcomplete"].includes(event)) {
      CLATimer.resume();
    }

    let isVerticalResolved = isVertical;
    if (window.jwplayer && videoRef.current) {
      try {
        const tw =
          window.jwplayer(videoRef.current).getPlaylistItem()?.typeWebView;
        if (typeof tw === "string" && tw.toLowerCase() === "vertical") {
          isVerticalResolved = true;
        } else if (typeof tw === "string" && tw.toLowerCase() === "normal") {
          isVerticalResolved = false;
        }
      } catch {
        /* noop */
      }
    }

    const videoTipo = getVideoTipo({ type, isVertical: isVerticalResolved });

    if (window.jwplayer && videoRef.current) {
      try {
        const rawTags = window.jwplayer(videoRef.current).getPlaylistItem()?.tags;
        const formatted = formatVideoTagForDataLayer(rawTags);
        if (formatted) {
          videoTagFromPlaylistRef.current = formatted;
        }
      } catch {
        /* noop */
      }
    }

    let videoTagStr =
      typeof videoTagOverride === "string" && videoTagOverride.trim() !== ""
        ? videoTagOverride.trim()
        : videoTagFromPlaylistRef.current || "";
    if (!videoTagStr && window.jwplayer && videoRef.current) {
      try {
        videoTagStr = formatVideoTagForDataLayer(
          window.jwplayer(videoRef.current).getPlaylistItem()?.tags
        );
      } catch {
        /* noop */
      }
    }

    const extraParams = {
      event: "jw_player_video",
      video_id: entityId,
      video_status: event,
      video_tipo: videoTipo != null ? String(videoTipo) : "",
      video_title: title,
      video_tag: videoTagStr != null ? String(videoTagStr) : "",
      eventCategory: "Video",
      eventAction: event,
      eventLabel: `${entityId} - ${title}`,
      eventValue: window.jwplayer(videoRef.current).getDuration(),
      nonInteraction: false,
    };

    if (typeof window !== "undefined" && entityId) {
      window.__jwPlayerDlCache = window.__jwPlayerDlCache || {};
      window.__jwPlayerDlCache[entityId] = {
        video_tipo: extraParams.video_tipo,
        video_tag: extraParams.video_tag,
      };
    }

    if (typeof sendGAPageview === "function") {
      sendGAPageview(extraParams);
    } else if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push(extraParams);
    }
  };

  useEffect(() => {
    if (isPreview) return;

    const existingLibraryScript = document.getElementById(jwPlayerCdnLink);
    if (!existingLibraryScript) {
      installPlayerScript();
    } 
    else if (window?.jwplayer) {
      initialize();
      document.addEventListener(nameCustomEvent, initialize, { once: true });
    } 
    else {
      document.addEventListener(nameCustomEvent, initialize, { once: true });
    }

    return () => {
      if (playerInstance && playerInstance?.current && typeof playerInstance.current.remove === "function") {
        playerInstance.current.remove();
      } else if (
        !isPreview &&
        window.jwplayer &&
        typeof window.jwplayer(videoRef.current)?.remove === "function"
      ) {
        window.jwplayer(videoRef.current).remove();
      }
      playerInstance.current = null;
    };
  }, [id]);

  useEffect(() => {
    if (playerInstance.current) {
      if (statePlayerHover === "play") {
        playerInstance.current.play();
      } else if (statePlayerHover === "pause") {
        playerInstance.current.pause();
      }
    }
  }, [statePlayerHover]);

  if (isPreview) {
    return (
      <div id={idDivPlayer} ref={videoRef} className="thumbnail-container">
        <img src={thumbnail} alt={title} style={{ width: "100%", height: "auto" }} />
      </div>
    );
  }

  return <div id={idDivPlayer} ref={videoRef} data-position={type} />;
};

export default JWPlayer;
